/* tslint:disable */
/* eslint-disable */
/**
 * Apideck
 * The Apideck OpenAPI Spec: SDK Optimized
 *
 * The version of the OpenAPI document: 10.13.0
 * Contact: support@apideck.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { Raw, RawFromJSON, RawToJSON } from './Raw'

/**
 *
 * @export
 * @interface DeleteConsumerResponse
 */
export interface DeleteConsumerResponse {
  /**
   * HTTP Response Status Code
   * @type {number}
   * @memberof DeleteConsumerResponse
   */
  status_code: number
  /**
   * HTTP Response Status
   * @type {string}
   * @memberof DeleteConsumerResponse
   */
  status: string
  /**
   *
   * @type {object}
   * @memberof DeleteConsumerResponse
   */
  data: object | null
  /**
   *
   * @type {Raw}
   * @memberof DeleteConsumerResponse
   */
  _raw?: Raw | null
}

export function DeleteConsumerResponseFromJSON(json: any): DeleteConsumerResponse {
  return DeleteConsumerResponseFromJSONTyped(json, false)
}

export function DeleteConsumerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DeleteConsumerResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status_code: json['status_code'],
    status: json['status'],
    data: json['data'],
    _raw: !exists(json, '_raw') ? undefined : RawFromJSON(json['_raw'])
  }
}

export function DeleteConsumerResponseToJSON(value?: DeleteConsumerResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status_code: value.status_code,
    status: value.status,
    data: value.data,
    _raw: RawToJSON(value._raw)
  }
}
